import React from 'react';
import { Star } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const testimonials = [
  { name: "Lakshmi Reddy", image: "/images/avatars/avatar-1.jpeg", project: "3BHK Interior, Hyderabad", review: "The team at Aura Spaces totally understood my vision. They delivered exactly what was promised, on time, and the finish quality is top-notch. Highly recommended!" },
  { name: "Padmavathi Prasad", image: "/images/avatars/avatar-2.jpeg", project: "Modular Kitchen, Guntur", review: "Aura Spaces transformed my outdated kitchen into a modern, highly functional space. The finish is premium and the space utilization is just brilliant." },
  { name: "Swathi Naidu", image: "/images/avatars/avatar-3.jpeg", project: "Office Renovation, Visakhapatnam", review: "From concept to execution, the journey was incredibly smooth. They managed the entire office renovation without disrupting our work schedule. The new space looks amazing." },
  { name: "Venkata Rao", image: "/images/avatars/avatar-4.jpeg", project: "Luxury Villa, Vijayawada", review: "I was extremely worried about budgets overshooting, but their transparent pricing kept everything in check. The 3D designs matched the final outcome perfectly." },
  { name: "Priya Reddy", image: "/images/avatars/avatar-5.jpeg", project: "Penthouse Design, Hyderabad", review: "Absolutely loved how they used every inch of space. The colour palette, the lighting — everything feels so warm and inviting. Best decision we made!" },
  { name: "Rajesh Raju", image: "/images/avatars/avatar-6.jpeg", project: "Restaurant Interiors, Warangal", review: "They created a fantastic ambiance for our new restaurant. We've been getting constant compliments from our customers about the interior design." },
  { name: "Srinivas & Family", image: "/images/avatars/avatar-7.jpeg", project: "Duplex Interior, Tirupati", review: "Professional team, zero delays, and the quality of materials used was outstanding. Our duplex looks like something out of a magazine now." },
];

export function TestimonialsSection() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const duplicated = [...testimonials, ...testimonials];

  return (
    <section aria-label="Client testimonials" className={`py-12 sm:py-24 overflow-hidden transition-colors duration-500 ${isDark ? 'bg-dark-bg' : 'bg-bg-light'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-16">
          <p className="text-xs sm:text-sm font-bold text-accent uppercase tracking-widest mb-2">Client Stories</p>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold mb-4 ${isDark ? 'text-white' : 'text-primary'}`}>
            Don't just take our word for it
          </h2>
        </div>
      </div>

      <div className="relative w-full overflow-hidden flex group">
        <div className="animate-marquee gap-8 px-4 py-8">
          {duplicated.map((t, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 rounded-2xl shadow-xl relative w-[300px] sm:w-[350px] md:w-[400px] shrink-0 ${isDark ? 'bg-[#1E293B] shadow-black/30' : 'bg-white shadow-gray-200/50'}`}
            >
              <div className="flex text-accent mb-6">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star key={star} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <p className={`mb-6 sm:mb-8 italic leading-relaxed text-sm sm:text-lg ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                "{t.review}"
              </p>
              <div className="flex items-center gap-4">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
                <div>
                  <p className={`font-poppins font-bold ${isDark ? 'text-white' : 'text-primary'}`}>{t.name}</p>
                  <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{t.project}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={`absolute inset-y-0 left-0 w-12 sm:w-32 bg-linear-to-r to-transparent pointer-events-none ${isDark ? 'from-dark-bg' : 'from-bg-light'}`} />
        <div className={`absolute inset-y-0 right-0 w-12 sm:w-32 bg-linear-to-l to-transparent pointer-events-none ${isDark ? 'from-dark-bg' : 'from-bg-light'}`} />
      </div>
    </section>
  );
}
